import { AddDocumentButton } from '@lmt/unicorn-shared/app/components/patients/profile/cases/components/documents/AddDocumentButton';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import clsx from 'clsx';
import React, { FC } from 'react';

import styles from './PatientPanelHeader.module.scss';

export interface Props {
  title: string;
  patientId?: number;
  children?: React.ReactNode;
  className?: string;
}

export const PatientPanelHeader: FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  const { patientId } = props;
  const claims = useClaims();
  return (
    <div className={clsx(styles.container, props.className)}>
      <div className={styles.title}>{props.title}</div>
      {patientId && claims.permissions.createOrEditDocuments && (
        <AddDocumentButton patientId={patientId} />
      )}
      {props.children}
    </div>
  );
};
